import React from 'react';
import { ArrowRight } from 'lucide-react';
import { type CTAContent } from '../lib/variants';

interface CTAProps {
  onOpenBooking: () => void;
  content: CTAContent;
}

const CTA: React.FC<CTAProps> = ({ onOpenBooking, content }) => {
  return (
    <section className="py-20 bg-slate-950 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-20 pointer-events-none">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-cyan-400 blur-3xl" />
        <div className="absolute top-1/2 right-0 w-64 h-64 rounded-full bg-cyan-500 blur-3xl" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-500/20 border border-orange-400/50 text-orange-300 text-sm font-bold mb-8">
          <span className="inline-block h-2 w-2 rounded-full bg-orange-400 animate-pulse" />
          {content.urgencyBadge}
        </div>

        <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6">
          {content.headline}
        </h2>
        <p className="text-xl text-slate-300 mb-4 max-w-2xl mx-auto">
          {content.subheadline}
        </p>
        <p className="text-lg text-slate-400 mb-10 max-w-2xl mx-auto">
          {content.description}
        </p>

        <button
          onClick={onOpenBooking}
          className="inline-flex items-center justify-center gap-2 px-12 py-5 bg-cyan-400 hover:bg-cyan-300 text-slate-950 rounded-xl font-extrabold text-xl shadow-2xl shadow-cyan-500/30 transition transform hover:-translate-y-1"
        >
          {content.ctaText}
          <ArrowRight className="h-6 w-6" />
        </button>

        <p className="mt-6 text-slate-500 text-sm">
          {content.trustSignals}
        </p>
      </div>
    </section>
  );
};

export default CTA;
